// 📦 Sidebar.js
import React from "react";
import LatexRender from "../../../../../layout/LatexRender";

export default function Sidebar({
  question,
  hasSubmitted,
  setHasSubmitted,
  hasSubmittedStep1,
  setHasSubmittedStep1,
  hasOutreached,
  setHasOutreached,
  handleNext,
  submitAnswer,
  step1Feedback,
  finalFeedback,
  answer,
  setAnswer,
  elapsedSeconds,
  sessionDifficulty,
  displayNumber,
  questionNumber
}) {

  return (
    <div className="contentCol">
      {/* 🔢 Progress */}
      <div className="drillCounter">🧩 dRill {displayNumber}/10</div>

      {/* 📦 Sidebar Box */}
      <div className="card">
          {/* Top buttons */}
          <div className="buttons">

            {/* 💡 Hint button */}
            <button
              onClick={() =>
                !hasOutreached && questionNumber <= 10 ? (
                    setHasOutreached(true)
                ) : (
                    setHasOutreached(false)
                )
              }
              className="buttonHint">
                <img
                  src="/images/hint.png"
                  alt="hint"
                  className="h-5"
                />
                <span>hint</span>
            </button>

            {/* ➡️ Next button */}
            <button
              onClick={() => {
                handleNext();
              }}
              className="buttonNext"
            >
              ＞
            </button>

          </div>

          {/* Middle section (explanation and hint)*/}
          <div className="flex flex-col justify-center items-center font-nunito font-semibold text-center h-full">

            {/* Forklaring baseret på sværhedsgrad */}
            {!hasSubmitted && !hasOutreached && !hasSubmittedStep1 ? (
              sessionDifficulty === "easy" ? (
                <span>
                  saml <LatexRender math={`\\text{}x\\text{}`} />'erne på venstre side af lighedstegnet og konstanterne på højre side
                </span>
              ) : (
                <span>skal vi skrue lidt op for sværhedsgraden?</span>
              )
            ) : !hasSubmitted && !hasOutreached && (step1Feedback?.correct !== false || answer === "") && (
              <span>
                nu kan du løse ligningen som vi gjorde i kapitel 1: fjern tallet foran <LatexRender math={`\\text{}x`} /> ved at lave den omvendte regneoperation på begge sider af lighedstegnet
              </span>
            )}

            {/* Hint */}
            {!hasSubmitted && !hasSubmittedStep1 && hasOutreached && (
              <span>
                husk at samle <LatexRender math={`\\text{}x\\text{}`} />'erne på den side med det højeste antal <LatexRender math={`\\text{}x\\text{}`} />'er - her skriver vi resultatet af denne samling på venstre side uanset hvad
              </span>
            )}

            {/* 🗯️ Feedback */}
            
            {/* Final answer */}
            {finalFeedback && hasSubmitted && (
              <div
                className={`feedback ${
                  finalFeedback?.correct
                    ? "feedbackCorrect"
                    : "feedbackWrong"
                }`}
              >
                <img
                  src={finalFeedback?.correct ? "/images/logo_happy.png" : "/images/logo_sad.png"}
                  alt="feedback"
                  className="h-[2rem]"
                />
                {finalFeedback.message}

              </div>
              )}

              {/* Step 1 */}
              {hasSubmittedStep1 && step1Feedback?.correct === false && !hasSubmitted && (
                <div className="feedback feedbackWrong">
                  <img
                    src="/images/logo_sad.png"
                    alt="forkert"
                    className="h-[2em]"
                  />
                  {step1Feedback.message}
                </div>
              )}

          </div>

          {/* Bottom buttons */}
          <div className="buttons">
            {/* Se video */}
            <button
              onClick={() => {
                window.open("https://www.youtube.com/watch?v=2g0v1q3x4aE", "_blank");
              }}
              className={`buttonVideo ${hasOutreached ? "" : "hide"}`}>
                se video
            </button>

            {/* 📤 Submit button */}
            <button
              onClick={(e) => {
                if (hasSubmitted && finalFeedback?.correct) {
                  // do nothing
                } else if (hasSubmitted) {
                  setHasSubmitted(false); // Let user try again
                  setAnswer("");
                  setHasOutreached(false);
                } else if (hasSubmittedStep1 && step1Feedback && step1Feedback?.correct) {
                  e.preventDefault();

                  const finalAnswer = parseFloat(answer.final_answer);

                  if (answer.final_answer === '' || isNaN(finalAnswer)) {
                    alert('Indtast hel tal i feltet.');
                    return;
                  }

                  // Value are valid numbers
                  submitAnswer(); // submit final answer
                  setHasSubmitted(true); 
                } else if (hasSubmittedStep1) {
                  setHasSubmittedStep1(false); // let user try step 1 again
                  setHasOutreached(false);
                  setAnswer("")
                } else if (questionNumber <= 10) {
                  e.preventDefault();

                  const xVal = parseFloat(answer.x);
                  const valVal = parseFloat(answer.val);

                  if (answer.x === '' || isNaN(xVal) || answer.val === '' || isNaN(valVal)) {
                    alert('Indtast hele tal i begge felter.');
                    return;
                  }

                  // Both values are valid numbers
                  submitAnswer();
                  setHasSubmittedStep1(true); 
                }
              }}
              className="buttonSubmit"
            >
              {((step1Feedback?.correct === false && hasSubmittedStep1) || (finalFeedback?.correct === false && hasSubmitted)) ? "prøv igen" : "indsend svar"}
            </button>

          </div>
      </div>
    </div>
  );
}